const riot = require('riot');

riot.tag2('page-error', '<div class="s-full f fh"> <div class="f fm fclm w-full text-center px16"> <div class="s-w-full mb32 s-mb72 text-primary fs190 s-fs130">{statusCode}</div> <div class="lh12 text-gray_dark_50 fw5 fs16 mb72">{description}</div><a class="button size-m flex-fixed mb72" href="/">トップに戻る</a> <div class="text-gray_dark_10 fw4 fs12">Powered by Repro Incentive</div> </div> </div>', 'page-error,[data-is="page-error"]{display:block} page-error .fs190,[data-is="page-error"] .fs190{font-size:190px}', '', function(opts) {
    this.preload = ({req, res}) => {
      let statusCode = res.statusCode;

      if (res.error.status) {
        statusCode = res.error.status;
      }

      let errorMessage = {
        403: {
          title: "Auth Error",
          description: "このページへのアクセス権限がありません。",
        },

        404: {
          title: "Page Not Found",
          description: "ページが見つかりません",
        },
      }[statusCode];

      if (!errorMessage) {
        errorMessage = {
          title: "Error",
          description: "エラーが発生しました。",
        };
      }
      return {
        statusCode,
        title: errorMessage.title,
        description: errorMessage.description,
      };
    };

    this.head = () => {
      return {
        title: app.utils.head.title(this.title, this),
      };
    };
});